import axios from "axios";
import { API_URL } from "../../constants";
import { getConfig, handleErrors } from "../../utils/utils";
import { XERO_INVOICING_REPORTS } from "../types";

export const fetchXeroInvoicingReports = () => async (dispatch, getState) => {
  try {
    const res = await axios.get(`${API_URL}/api/reports/xero-invoicing`, {
      ...getConfig(),
    });
    // console.log(res.data);
    localStorage.setItem('xeroInvoicingReports', JSON.stringify(res.data));
    const payload = res.data.data;
    dispatch({ type: XERO_INVOICING_REPORTS.FETCH_SUCCESS, payload });
  } catch (error) {
    dispatch({ type: XERO_INVOICING_REPORTS.FETCH_FAILED });

    handleErrors(error);
  }
};
